export default "__VITE_ASSET__CTVlkHIR__"